import { AttributeOperators, KeyType } from '@enums/strapiTypesAndOperators'

export const getFilters = pageFooterTagName => [
    {
        key: KeyType.PAGE_TAG_FILTER_1,
        operator: AttributeOperators.CONTAINSI,
        value: `,${pageFooterTagName}`,
    },
    {
        key: KeyType.PAGE_TAG_FILTER_2,
        operator: AttributeOperators.CONTAINSI,
        value: ` ${pageFooterTagName}`,
    },
    {
        key: KeyType.PAGE_TAG_FILTER_3,
        operator: AttributeOperators.STARTS_WITHI,
        value: pageFooterTagName,
    },
    {
        key: KeyType.PAGE_TAG_FILTER_4,
        operator: AttributeOperators.CONTAINSI,
        value: `${pageFooterTagName},`,
    },
    {
        key: KeyType.PAGE_TAG_FILTER_5,
        operator: AttributeOperators.CONTAINSI,
        value: `${pageFooterTagName} `,
    },
    {
        key: KeyType.PAGE_TAG_FILTER_6,
        operator: AttributeOperators.ENDS_WITHI,
        value: pageFooterTagName,
    },
]
